<template>
    <div class="mask" v-if="dataVal.flag">
        <div class="mask-content">
            <div class="mask-content-header">
                <div>{{ type == 'see' ? '查看课程' : type == 'add' ? '新增课程' : type == 'edit' ? '编辑课程' : '' }}</div>
                <div @click="handleRefund">
                    <el-icon name="close" size="16"></el-icon>
                </div>
            </div>
            <div class="mask-content-body">
                <div class="mask-content-body-cen">
                    <div class="mask-content-body-select">
                        <div class="mask-content-body-select-title">课程名称<span>*</span>：</div>
                        <div class="mask-content-body-select-input">
                            <el-input v-model="form.name" clearable placeholder="请输入课程名称"></el-input>
                        </div>
                    </div>
                    <div class="mask-content-body-select">
                        <div class="mask-content-body-select-title">课程老师<span>*</span>：</div>
                        <div class="mask-content-body-select-input">
                            <!-- <el-select v-model="form.teacher_id" placeholder="请选择课程老师" popper-class="groupselsect"
                                popper-append-to-body>
                                <el-option v-for="item in options" :key="item.id" :label="item.nickname"
                                    :value="item.id">
                                </el-option>
                            </el-select> -->
                            <el-input v-model="form.teacher" clearable placeholder="请输入课程老师"></el-input>
                        </div>
                    </div>
                    <div class="mask-content-body-select">
                        <div class="mask-content-body-select-title">课程日期<span>*</span>：</div>
                        <div class="mask-content-body-select-input">
                            <el-date-picker v-model="riqi" type="date" format="yyyy-MM-dd" placeholder="请选择课程开始时间"
                                popper-class="groupselsect" append-to-body>
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="mask-content-body-select">
                        <div class="mask-content-body-select-title">课程时间<span>*</span>：</div>
                        <div class="mask-content-body-select-input">
                            <!-- <el-date-picker v-model="stime" type="datetime" placeholder="请选择课程开始时间"
                                popper-class="groupselsect" append-to-body>
                            </el-date-picker> -->
                            <el-time-picker v-model="stime" type="datetime" format="HH:mm" placeholder="请选择课程开始时间"
                                popper-class="groupselsect" append-to-body>
                            </el-time-picker>
                            <!-- <el-input v-model="form.stime" clearable placeholder="请输入课程开始时间"></el-input> -->
                            <span class="mask-content-body-select-input-span">~</span>
                            <!-- <el-date-picker v-model="etime" type="datetime" placeholder="请选择课程结束时间"
                                popper-class="groupselsect" append-to-body>
                            </el-date-picker> -->
                            <el-time-picker v-model="etime" type="datetime" format="HH:mm" placeholder="请选择课程结束时间"
                                popper-class="groupselsect" append-to-body>
                            </el-time-picker>
                            <!-- <el-input v-model="form.etime" clearable placeholder="请输入课程结束时间"></el-input> -->
                        </div>
                    </div>
                    <div class="mask-content-body-select mask-content-body-select2">
                        <div class="mask-content-body-select-title">课程介绍<span>*</span>：</div>
                        <div class="mask-content-body-select-input">
                            <el-upload class="avatar-uploader" :action="uploadimg" list-type="picture-card"
                                :on-remove="handleRemove" :headers="headers" accept="image/jpg,image/jpeg,image/png"
                                :show-file-list="true" multiple :file-list="fileList" :on-success="handleAvatarSuccess"
                                :limit="12" :on-exceed="handleExceed" :before-upload="beforeAvatarSuccess">
                                <div class="el-upload__tip">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                    <span class="avatar-uploader-text">上传图片</span>
                                </div>
                            </el-upload>
                        </div>
                    </div>
                    <div class="mask-content-body-select mask-content-body-select2">
                        <div class="mask-content-body-select-title">课程资料：</div>
                        <div class="mask-content-body-select-input">
                            <el-upload class="upload-demo" drag :action="uploadfile" :headers="headers" multiple
                                :file-list="fileList2" :on-remove="handleRemove2" :on-success="handleAvatarSuccess2">
                                <div class="el-upload__text"><em>点击上传</em> / 拖拽到此区域</div>
                            </el-upload>
                        </div>
                    </div>
                </div>
                <div class="mask-content-footer">
                    <div @click="handleRefund" v-if="type != 'see'">取消</div>
                    <div @click="handleSubmit">确定</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "AddGroup",
    props: ['dataVal'],
    data() {
        return {
            urls: this.imgurl,
            type: '',

            options: [],
            value: '',
            value1: '',
            value2: '',

            headers: {
                token: localStorage.getItem("token"),
            },
            fileList: [],
            fileList2: [],

            riqi: '',
            stime: '',
            etime: '',
            form: {
                activity_id: '',
                banji_id: '',
                name: '',
                teacher_id: '',
                teacher: '',
                riqi: '',
                stime: '',
                etime: '',
                detailimages: '',
                attachs: '',
            }
        };
    },
    mounted() {
    },
    methods: {
        async activityCourseedit() {
            let res = await this.$api.activityCourseedit(this.form)
        },
        async activityGetteacher() {
            let res = await this.$api.activityGetteacher()
            if (res.code == 1) {
                this.options = res.data
            }
        },
        //取消弹窗
        handleRefund() {
            let data = {
                flag: false,
                submitFlag: false
            }
            this.$emit("addClassCall", data);
        },
        async handleSubmit() {
            if (this.type == 'see') {
                this.handleRefund()
            } else {
                let res = await this.$api.activityCourseedit(this.form)
                if (res.code == 1) {
                    let data = {
                        flag: false,//弹窗是否显示
                        submitFlag: true//是否调用接口
                    }
                    this.$emit("addClassCall", data);
                }
            }
        },
        handleAvatarSuccess(res, file, fileList) {
            if (res.code == 1) {
                fileList.forEach((item, index) => {
                    if (item.uid == file.uid) {
                        item.url = this.urls + res.data.imgsrc
                    }
                })
                this.fileList = fileList
            }
        },
        handleAvatarSuccess2(res, file, fileList) {
            if (res.code == 1) {
                fileList.forEach((item, index) => {
                    if (item.uid == file.uid) {
                        item.url = this.urls + res.data.file
                    }
                })
                this.fileList2 = fileList

                console.log(this.fileList2)
            }
        },
        beforeAvatarSuccess(file) {
            var img = file.name.substring(file.name.lastIndexOf(".") + 1);
            const suffix = img === "jpg" || "JPG";
            const suffix2 = img === "png" || "PNG";
            const suffix3 = img === "jpeg" || "JPEG";
            // const isLt35M = file.size / 1024 / 1024 < 20; // 限制为小于35MB
            if (!suffix && !suffix2 && !suffix3) {
                this.$message.error("只能上传图片！");
                return false;
            }
            // if (!isLt35M) {
            //     this.$message.error("图片大小不能超过35MB");
            // }
            // return (suffix || suffix2 || suffix3) && isLt35M;
            return suffix || suffix2 || suffix3;
        },
        handleRemove(file, fileList) {
            this.fileList = fileList
            console.log(file, fileList);
        },
        handleRemove2(file, fileList) {
            this.fileList2 = fileList
            console.log(file, fileList);
        },
        //图片超出限制
        handleExceed(files, fileList) {
            this.fileList = fileList
            this.$message.warning("图片个数超出限制");
        },

    },
    watch: {
        dataVal: {
            handler(newVal, oldVal) {
                console.log(newVal)
                if (newVal.flag) {
                    this.activityGetteacher()
                    this.type = newVal.type
                    this.form.activity_id = newVal.data.activity_id
                    this.form.banji_id = newVal.data.banji_id
                    if (newVal.data.id) {
                        this.form.id = newVal.data.id ? newVal.data.id : ''
                        this.form.name = newVal.data.name ? newVal.data.name : ''
                        this.form.teacher_id = newVal.data.teacher_id ? newVal.data.teacher_id : ''
                        this.form.teacher = newVal.data.teacher ? newVal.data.teacher : ''
                        this.form.riqi = newVal.data.riqi ? newVal.data.riqi : ''
                        this.form.stime = newVal.data.stime ? newVal.data.stime : ''
                        this.form.etime = newVal.data.etime ? newVal.data.etime : ''
                        this.form.detailimages = newVal.data.detailimages ? newVal.data.detailimages : ''
                        this.form.attachs = newVal.data.attachs ? newVal.data.attachs : ''

                        let imagelist = this.form.detailimages.split(',')
                        let fileList = []
                        imagelist.forEach((item, index) => {
                            fileList.push({
                                name: '',
                                percentage: 100,
                                raw: {},
                                response: {},
                                size: 1206,
                                status: "success",
                                uid: 1758180136738 + index,
                                url: this.urls + item
                            })
                        })
                        this.fileList = fileList


                        let attachsList = this.form.attachs ? this.form.attachs.split(',') : []
                        let fileList2 = []
                        attachsList.forEach((item, index) => {
                            fileList2.push({
                                name: item.slice(item.lastIndexOf('/') + 1),
                                percentage: 100,
                                raw: {},
                                response: {},
                                size: 1206,
                                status: "success",
                                uid: 1758180136738 + index,
                                url: this.urls + item
                            })
                        })
                        this.fileList2 = fileList2

                        let riqinum = Number(this.form.riqi) * 1000
                        this.riqi = new Date(riqinum)
                        let stimedata = this.form.stime ? '2024-1-1 ' + this.form.stime : ''
                        let etimedata = this.form.etime ? '2024-1-1 ' + this.form.etime : ''
                        this.stime = new Date(stimedata)
                        this.etime = new Date(etimedata)
                    } else {
                        this.form.id = ''
                        this.form.name = ''
                        this.form.teacher_id = ''
                        this.form.teacher = ''
                        this.form.riqi = ''
                        this.form.stime = ''
                        this.form.etime = ''
                        this.form.detailimages = ''
                        this.form.attachs = ''
                        this.fileList = []
                        this.fileList2 = []

                        this.riqi = ''
                        this.stime = ''
                        this.etime = ''
                    }
                }
            },
            deep: true
        },
        fileList: {
            handler(newVal, oldVal) {
                let imagelist = []
                newVal.forEach(item => {
                    if (item.status == "success") {
                        let url = item.url.replace(this.urls, '')
                        imagelist.push(url)
                    }
                })
                this.form.detailimages = imagelist.toString()
                console.log(this.form.detailimages)
            },
            deep: true
        },
        fileList2: {
            handler(newVal, oldVal) {
                let imagelist = []
                newVal.forEach(item => {
                    if (item.status == "success") {
                        let url = item.url.replace(this.urls, '')
                        imagelist.push(url)
                    }
                })
                this.form.attachs = imagelist.toString()
                console.log(this.form.attachs)
            },
            deep: true
        },
        stime: {
            handler(newVal, oldVal) {
                let d = new Date(newVal)
                let hour = d.getHours();
                hour = hour > 9 ? hour : "0" + hour.toString();
                let minute = d.getMinutes();
                minute = minute > 9 ? minute : "0" + minute.toString();
                this.form.stime = `${hour}:${minute}`
                console.log(this.form.stime)
            },
            deep: true
        },
        etime: {
            handler(newVal, oldVal) {
                let d = new Date(newVal)
                let hour = d.getHours();
                hour = hour > 9 ? hour : "0" + hour.toString();
                let minute = d.getMinutes();
                minute = minute > 9 ? minute : "0" + minute.toString();
                this.form.etime = `${hour}:${minute}`
                console.log(this.form.etime)
            },
            deep: true
        },
        riqi: {
            handler(newVal, oldVal) {
                this.form.riqi = new Date(newVal).getTime() / 1000
                console.log(this.form.riqi)
            },
            deep: true
        }
    }
};
</script>

<style lang="scss" scoped>
.mask {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 99999;

    .mask-content {
        width: 715px;
        border-radius: 10px;
        background: #FFF;
        overflow: hidden;
        position: fixed;

        .mask-content-header {
            width: 100%;
            min-height: 50px;
            background: #C12E30;
            display: flex;
            align-items: center;
            justify-content: space-between;
            padding: 10px 20px;

            div {
                color: var(--Gray-White, #FFF);
                font-size: 16px;
            }

            .el-icon-close {
                color: #FFF;
            }
        }

        .mask-content-body {
            width: 100%;
            background-color: #FFF;
            padding: 20px 20px 34px 20px;

            .mask-content-body-cen {
                width: 100%;
                min-height: 550px;

                .mask-content-body-select {
                    width: 100%;
                    display: flex;
                    align-items: center;
                    margin-bottom: 20px;

                    .mask-content-body-select-title {
                        width: 87px;
                        color: #A6A6A6;
                        font-size: 14px;
                        display: flex;
                        align-items: center;

                        span {
                            color: #C12E30;
                        }
                    }

                    /deep/ .mask-content-body-select-input {
                        flex: 1;
                        display: flex;
                        align-items: center;

                        .el-select {
                            flex: 1;
                        }

                        .el-date-editor {
                            flex: 1;
                        }

                        .mask-content-body-select-input-span {
                            width: 30px;
                            color: #A6A6A6;
                            font-size: 14px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        }

                        .avatar-uploader {
                            .el-upload {
                                border: 1px dashed #DCDCDC;
                                background: #E7E7E7;
                            }
                        }

                        .el-upload__tip {
                            width: 100%;
                            height: 100%;
                            flex-direction: column;
                            @include flex-center(center, center);

                            .avatar-uploader-text {
                                color: rgba(0, 0, 0, 0.40);
                                font-size: 12px;
                                line-height: normal;
                                margin-top: 10px;
                            }
                        }

                        .upload-demo {
                            width: 100%;

                            .el-upload {
                                width: 100%;

                                .el-upload-dragger {
                                    width: 100%;
                                    height: 50px;
                                    display: flex;
                                    align-items: center;
                                    justify-content: center;
                                }
                            }
                        }
                    }
                }

                .mask-content-body-select2 {
                    display: flex;
                    align-items: normal;

                    .mask-content-body-select-title {
                        align-items: normal;
                        line-height: 40px;
                    }
                }
            }

            .mask-content-footer {
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-end;
                margin-top: 27px;

                div {
                    width: 120px;
                    height: 40px;
                    color: rgba(0, 0, 0, 0.90);
                    font-size: 14px;
                    border-radius: 5px 0 0 5px;
                    background: #EDC2C3;
                    @include flex-center(center, center);
                    cursor: pointer;

                    &:nth-child(2) {
                        border-radius: 0 5px 5px 0;
                        color: rgba(255, 255, 255, 0.90);
                        background: #B30003;
                    }
                }
            }
        }
    }
}

.el-date-picker {
    z-index: 9999 !important;
}
</style>